// src/components/stamps/StampCard.jsx
import React from "react";
import "./stamps.css";

// ... (Theme logic remains the same) ...
const themes = [
  [["#FF0080", 10, 10, 70], ["#7928CA", 90, 90, 70], ["#FF4D4D", 50, 50, 50]],
  [["#007CF0", 0, 100, 80], ["#00DFD8", 100, 0, 70], ["#7928CA", 50, 50, 40]],
  [["#FF4D4D", 0, 0, 80], ["#F9CB28", 100, 100, 80], ["#FF0080", 100, 0, 50]],
  [["#7928CA", 0, 0, 70], ["#FF0080", 100, 0, 50], ["#00DFD8", 50, 100, 80]],
  [["#F9CB28", 10, 50, 70], ["#FF4D4D", 90, 50, 70], ["#FB923C", 50, 0, 60]],
  [["#4F46E5", 20, 20, 80], ["#C026D3", 80, 80, 80], ["#22D3EE", 50, 50, 50]],
];

function getGradientStyle(index) {
  const activeTheme = themes[index % themes.length];
  return activeTheme
    .map(
      ([color, x, y, size]) =>
        `radial-gradient(circle at ${x}% ${y}%, ${color} 0%, transparent ${size}%)`
    )
    .join(",");
}

export default function StampCard({ item, index = 0, flipped, onToggle, rotateDeg = 0 }) {
  const gradientString = getGradientStyle(index);

  return (
    <button
      type="button"
      onClick={() => onToggle(item.id)}
      className="group relative w-full p-2 text-left outline-none"
      style={{ transform: `rotate(${rotateDeg}deg)` }}
      aria-pressed={flipped}
    >
      {/* ✅ FIX APPLIED HERE:
         1. Added 'bg-transparent' to ensure the wrapper has no color.
         2. Added 'rounded-[22px]' to match the inner card shape exactly.
      */}
      <div className="stamp relative shadow-xl transition-shadow duration-300 hover:shadow-2xl shadow-black/5 bg-transparent rounded-[22px]">
        
        <div className="relative rounded-[22px] overflow-hidden border border-white/20">
          
          {/* --- BACKGROUND LAYER --- */}
          <div className="absolute inset-0 z-0">
             <div
              className="absolute inset-0 w-full h-full opacity-90"
              style={{
                backgroundImage: gradientString,
                filter: "blur(60px) saturate(1.4)",
                transform: "scale(1.2)", 
              }}
            />
            <div className="absolute inset-0 bg-white/20 mix-blend-overlay" />
          </div>

          {/* --- CONTENT LAYER --- */}
          <div className="relative z-10 h-[240px] w-full [perspective:900px]">
            <div
              className={[
                "absolute inset-0 transition-transform duration-500 [transform-style:preserve-3d]",
                flipped ? "[transform:rotateY(180deg)]" : "",
              ].join(" ")}
            >
              {/* FRONT */}
              <div className="absolute inset-0 z-10 [backface-visibility:hidden]">
                <div className="relative h-full w-full px-6 py-5 flex flex-col">
                  <div className="text-[12px] uppercase tracking-[0.18em] text-black/60 font-bold">
                    question
                  </div>
                  <div className="mt-3 flex-1 overflow-auto pr-2">
                    <div className="text-[20px] font-bold leading-snug text-black">
                      {item.question}
                    </div>
                  </div>
                  <div className="mt-4 flex justify-center">
                    <span className="rounded-full border border-white/30 bg-white/40 backdrop-blur-md px-3 py-1 text-xs font-bold text-black/70 shadow-sm">
                      click to reveal
                    </span>
                  </div>
                </div>
              </div>

              {/* BACK */}
              <div className="absolute inset-0 z-10 [transform:rotateY(180deg)] [backface-visibility:hidden]">
                <div className="relative h-full w-full px-6 py-5 flex flex-col">
                  <div className="text-[12px] uppercase tracking-[0.18em] text-black/60 font-bold">
                    answer
                  </div>
                  <div className="mt-3 flex-1 overflow-auto pr-2">
                    <div className="text-[20px] font-bold leading-snug text-black">
                      {item.answer}
                    </div>
                  </div>
                  <div className="mt-4 flex justify-center">
                    <span className="rounded-full border border-white/30 bg-white/40 backdrop-blur-md px-3 py-1 text-xs font-bold text-black/70 shadow-sm">
                      click to flip back
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <style>{`
            .stamp .overflow-auto::-webkit-scrollbar { width: 6px; }
            .stamp .overflow-auto::-webkit-scrollbar-thumb {
              background: rgba(0,0,0,0.2);
              border-radius: 999px;
            }
            .stamp .overflow-auto::-webkit-scrollbar-track { background: transparent; }
          `}</style>
        </div>
      </div>
    </button>
  );
}